
export function toNumber( val: unknown ): number|never {
    const num = Number(val);
    if (!Number.isFinite(num)) throw new Error(`Value conversion to number failed with value: ${val}`);
    return num;
}